<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link to="/" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Informasi & Promo</div>
        </div>
        <!-- * App Header -->

        <!-- App Capsule -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section inset mt-2" v-if="info.data.length > 0">
                <div class="wide-block pt-0 pl-0 pr-0 pb-2 mb-2" v-for="(item, index) in info.data" :key="index">
                    <img v-if="item.image != null" :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/banner/'+item.image" class="w-100 full" style="border-top-left-radius: 7px;border-top-right-radius: 7px;border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;">
                    <div class="p-2">
                        <h3><strong class="strong-bold">{{ item.title }}</strong></h3>
                        <article class="info-content" v-html="item.content"></article>
                        <footer><i>{{ item.created_at }}</i></footer>
                    </div>
                </div>
                <!-- <ul class="listview image-listview">
                    <li v-for="(item, index) in info.data" :key="index">
                        <a class="item pl-3 pr-3" style="cursor:pointer" @click="showModal('show', item.title, item.content, item.image)">
                            <div class="icon-box bg-primary">
                                <ion-icon name="information-circle-outline"></ion-icon>
                            </div>
                            <div class="in">
                                <div>
                                    <div class="mb-05"><strong>{{ item.title }}</strong></div>
                                    <div class="text-small mb-05">{{ (item.content.length > 50 ? item.content.substring(0,50)+'...':item.content) | strip_tags }}</div>
                                    <div class="text-xsmall">{{ item.created_at }}</div>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul> -->
                <div class="m-2 text-center" v-if="info.next_page_url">
                    <ButtonLoader :loading="loading.button" :styled="'btn btn-primary rounded mr-1 mb-1'" @click.native="paginate(info.next_page_url)">Lihat lebih banyak</ButtonLoader>
                </div>
            </div>

            <div class="section mt-2" v-else >
                <div class="text-center" style="margin-top:100px;">
                    <img :src="require('@/assets/image/404.svg')" alt="404" class="w-75 mb-3"><br>
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
        <!-- * App Capsule -->

        <Modal ref="modal" :loading="loadingModal" :title="info_show.title">
            <div v-if="info_show.image != null" class="mb-1 mt-1">
                <img :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/banner/'+info_show.image" class="imaged w-100">
            </div>
            <div v-html="info_show.content"></div>
        </Modal>
    </div>
</template>
<script>
import $axios from './../../api.js'
import { mapState } from 'vuex'
export default {
    name: 'Info',
    props: ['information_id'],
    data() {
        return {
            info: {},
            loadingApp: true,
            loadingModal: false,
            info_show:{
                title: '',
                content: '',
                image: null
            }
        }
    },
    computed: {
        ...mapState(['loading','VUE_ENV'])
    },
    methods: {
        showModal(value, title, content, image){
            this.info_show = {
                title: title,
                content: content,
                image: image
            }
            let element = this.$refs.modal.$el
            window.$(element).modal(value)
        },
        paginate(url = ''){
            this.$store.commit('SET_LOADING', {button:true})
            $axios.get(url ? url:'/info')
            .then(response => {
                if(!this.info.data){
                    this.info = response.data
                }else{
                    this.info.data.push(...response.data.data)
                    this.info.next_page_url = response.data.next_page_url
                }
                this.$store.commit('SET_LOADING', {button:false})
                this.loadingApp = false
            }).catch(() => {
                this.$store.commit('SET_LOADING', {button:false})
                this.loadingApp = false
            })
        }
    },
    mounted() {
        this.paginate()
        if(this.information_id != undefined){
            $axios.get('/info/'+this.information_id)
            .then(response => {
                this.showModal('show', response.data.info.title, response.data.info.content, response.data.info.image)
            })
        }
    },
    filters:{
        strip_tags: function(string) {
            return string.replace(/<\/?[^>]+(>|$)/g, "");
        }
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
    },
}
</script>